<template>
<vs-card class="cardx">
    <div class="container">
    <form action="" class="form-horizontal">
        <div class="ps_divG">Registro AI BoxStreamer</div>
        <vs-input label="Tiempo Límite De Pre-Registro [horas]" type="text" class="inputx" v-model="form.limit_time_pre_registration"/><br>
        <vs-input label="Tiempo Límite De Registro [horas]" type="text" class="inputx" v-model="form.limit_time_register"/><br>
        <div class="ps_divG">Estado De Alarma AI BoxStreamer</div>
        <vs-input label="Límite De La Cantidad De Alertas Para Mostrar" type="text" class="inputx" v-model="form.limit_qty_show_alert"/><br>
        <vs-input label="Límite De La Cantidad De Alertas Para Mostrar sin fecha" type="text" class="inputx" v-model="form.limit_qty_show_alert_without_date"/><br>
        <vs-input label="Límite De Time De Inactividad Del AI BoxStreamer [minutes]" type="text" class="inputx" v-model="form.limit_time_inactive"/><br>
        <vs-input label="Intervalo De Tiempo De Actualización De Actividad [seconds]" type="text" class="inputx" v-model="form.time_interval"/><br>
        <div class="ps_divG">Puertos De Conexión AI Boxstreamer Streamer</div>
        <div class="input-group">
        <vs-input label="Camara Trasera" type="text" class="inputx p_ps" v-model="form.port.rear"/><vs-input label="Camara Frontal" type="text" class="inputx p_ps" v-model="form.port.front"/>
        <vs-input label="Camara Izquierda" type="text" class="inputx p_ps" v-model="form.port.left"/><vs-input label="Camara Derecha" type="text" class="inputx p_ps" v-model="form.port.right"/>
        </div><br>
        <div class="ps_divG">Estado De Las Camaras</div>
        <vs-input label="Indicador De Calidad - Límite 100%" type="text" class="inputx" v-model="form.quality_indicator"/><br>
        <vs-button class="bx bxs-paint-roll ml-3 ps_bx" @click="postGeneralConfig()" color="darkgreen" type="border" icon="update">Update</vs-button>
    </form>
    </div>
    <br><br>
    <vs-alert class="ps_alert" color="danger" v-if="show" :active.sync="active1" closable close-icon="close">S
        {{msg}}
    </vs-alert>
    <vs-alert class="ps_alert" color="success" v-if="show1" :active.sync="active1" closable close-icon="close">
        {{msg}}
    </vs-alert>
</vs-card>
</template>
<script>
import axios from 'axios'
export default {
    name: "generalConfig",
    props:{
        id: String
    },
    components: {
},
    data:()=>({
    active1:true,
    msg: '',
    show: false,
    show1: false,
    form: {
        "id":"",
        "limit_time_pre_registration": "",
        "limit_time_register": "",
        "limit_qty_show_alert": "",
        "limit_qty_show_alert_without_date": "",
        "limit_time_inactive": "",
        "time_interval": "",
        "quality_indicator":"",
        "port": {
            "rear": "",
            "front": "",
            "left": "",
            "right": "",
        },
    },
    error_msg: ''
    }),
    methods: {
    scrollInto(elementId) {
        const section = document.querySelector(`#${elementId}`);
        section.scrollIntoView({
        behavior: 'smooth'
        });
    },
    getGeneralConfig(){
        const url_api = this.$store.state.url_api
        axios.get(url_api + 'api/generalConfig').then(response => {
        this.form.id = response.data.id
        this.form.limit_time_pre_registration = response.data.limit_time_pre_registration
        this.form.limit_time_register = response.data.limit_time_register
        this.form.limit_qty_show_alert = response.data.limit_qty_show_alert
        this.form.limit_qty_show_alert_without_date = response.data.limit_qty_show_alert_without_date
        this.form.limit_time_inactive = response.data.limit_time_inactive
        this.form.time_interval = response.data.time_interval
        this.form.port.rear = response.data.port_rear
        this.form.port.front = response.data.port_front
        this.form.port.left = response.data.port_left
        this.form.port.right = response.data.port_right
        this.form.quality_indicator = response.data.quality_indicator

        })
        .catch((error) => {
        this.error_msg = error.response.data
        })
    },
    postGeneralConfig(){
        const url_api = this.$store.state.url_api
        axios.post(url_api + 'api/generalConfigUpdate', this.form).then(response => {
        if (response.data['isOk'] == true){
            this.show = false
            this.show1 = true
            this.msg = response.data['message']
            this.active1 = true
        }
        else{
            this.show = true
            this.show1 = false
            this.msg = response.data['message']
            this.active1 = true
        }
        })
        .catch((error) => {
        this.error_msg = error.response.data
        })
    },
    },
    mounted(){
    this.getGeneralConfig()
    }
}
</script>
<style>
    .ps_divG{
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 1em;
        font-weight: bold;
    }
    .ps_alert{
    margin-top: 1em;
    max-width: 50%;
    }
    .ps_bx{
        float: right !important;
    }

    element.style {
        font-weight: bold;
    }
    .p_ps{
        margin-right: 1em;
    }
</style>